import { useEffect, useState } from "react";
import api from "../api";

const EUR = (n) => "€ " + Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function RevenueTransfers() {
  const [rows, setRows] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/invoices/transfers", { noCache: true }).then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => {
    load();
    api.get("/companies").then((r) => setCompanies(r.data.filter((c) => c.kind !== "lead").sort((a, b) => (a.name || "").localeCompare(b.name || "", "it")))).catch(() => {});
  }, []);

  const add = async () => {
    if (!from || !to || !amount) { alert("Scegli i due clienti e l'importo."); return; }
    setBusy(true);
    try {
      await api.post("/invoices/transfers", { from_company_id: from, to_company_id: to, amount: Number(amount), note });
      setFrom(""); setTo(""); setAmount(""); setNote("");
      load();
    } catch (e) { alert(e.response?.data?.detail || e.message); }
    setBusy(false);
  };
  const del = async (r) => {
    if (!window.confirm(`Eliminare il giroconto ${r.from_name} → ${r.to_name} (${EUR(r.amount)})?`)) return;
    setBusy(true);
    try { await api.delete(`/invoices/transfers/${r.id}`); load(); }
    catch (e) { alert(e.response?.data?.detail || e.message); }
    setBusy(false);
  };

  if (rows === null) return null;
  return (
    <div className="panel" data-testid="transfers-panel">
      <div className="toolbar"><h3 style={{ margin: 0 }}>🔁 Importi fatturati per conto di altri clienti</h3></div>
      <p className="muted" style={{ fontSize: 12, marginTop: 4 }}>
        Se fatturi a un cliente un compenso che riguarda un altro (es. i €300 annui di un forfettario fatturati alla società),
        crea qui la regola: ogni anno l'importo viene <b>tolto dal fatturato del cliente a cui emetti la fattura e attribuito al beneficiario</b>,
        così i margini di entrambi sono corretti. Vale per ogni anno finché non elimini la regola.
      </p>
      {rows.length > 0 && (
        <table style={{ fontSize: 13 }} data-testid="transfers-table">
          <thead><tr><th>Fatturato a</th><th></th><th>Di competenza di</th><th style={{ textAlign: "right" }}>Importo annuo</th><th>Nota</th><th></th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{r.from_name}</td>
                <td style={{ textAlign: "center" }}>→</td>
                <td>{r.to_name}</td>
                <td style={{ textAlign: "right", fontWeight: 700 }}>{EUR(r.amount)}</td>
                <td className="muted">{r.note || "—"}</td>
                <td style={{ textAlign: "right" }}><button className="btn sm danger" disabled={busy} onClick={() => del(r)} data-testid={`transfer-del-${r.id}`}>🗑</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end", marginTop: 10 }}>
        <div className="field" style={{ margin: 0, minWidth: 220 }}><label>Fatturato a (chi riceve la fattura)</label>
          <select value={from} onChange={(e) => setFrom(e.target.value)} data-testid="transfer-from">
            <option value="">— scegli —</option>
            {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <div className="field" style={{ margin: 0, minWidth: 220 }}><label>Di competenza di (beneficiario)</label>
          <select value={to} onChange={(e) => setTo(e.target.value)} data-testid="transfer-to">
            <option value="">— scegli —</option>
            {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <div className="field" style={{ margin: 0, width: 130 }}><label>Importo annuo €</label>
          <input type="number" min="0" step="50" value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="transfer-amount" />
        </div>
        <div className="field" style={{ margin: 0, flex: 1, minWidth: 160 }}><label>Nota (facoltativa)</label>
          <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="es. compenso annuo dicembre" data-testid="transfer-note" />
        </div>
        <button className="btn primary" onClick={add} disabled={busy} data-testid="transfer-add">{busy ? "Salvo…" : "+ Aggiungi"}</button>
      </div>
    </div>
  );
}
